
<div>
  <div class="form__group--border pt-32 pb-16">
    <fieldset>
      <legend class="form__label pb-8">{{ legend }}</legend>
      <ul>
        <li v-for="experienceType in experienceTypes" :key="experienceType.value">
          <PoppinsCheckbox
            v-model="experience"
            name="caretype-experience"
            :labelName="experienceType.optionText"
            :aria-label="generateScreenReaderLabel(experienceType.optionText)"
            :value="experienceType.value"
          />
        </li>
      </ul>
    </fieldset>
  </div>
</div>
